import PropTypes from 'prop-types'
import React, { useEffect } from "react"
import { Row, Col, Alert, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userForgetPassword } from "../../store/actions"

// import images
import logo from "../../assets/images/logo-sm-dark.png";
import login from "../../assets/images/login/smart2.PNG";

const ForgetPasswordPage = props => {
  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  function handleValidSubmit(event, values) {
    props.userForgetPassword(values, props.history)
  }

  return (
    <React.Fragment>
       <div className="bg-page">
     
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="login-page-content">


          <Col md={6} lg={6} xl={5}>
              <div className="login-container">
                <img src={login} alt="" />
              </div>
              <div className="mt-5 text-center login-p desktop">
              <p>
                 Remember it ?
                  <Link to="/login" className="fw-medium text-primary">
                    Login in here
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} Smart School, Created
                  <i className="mdi mdi-heart text-danger"></i> by Chadrack_code
                </p>
              </div>
            </Col>


            <Col md={8} lg={6} lg={5}>
              <div className="card overflow-hidden">
                <div className="bg-login text-center">
                  <div className="bg-login-overlay"></div>
                  <div className="position-relative">
                    <h5 className="text-white font-size-20">Reset Password</h5>
                    <p className="text-white-50 mb-0">Re-Password with Qovex.</p>

                    <a href="/" className="logo logo-admin mt-4">
                      <img src={logo} alt="" height="30" />
                    </a>
                  </div>
                </div>
                <div className="card-body pt-5">

                  <div className="p-2">
                    {props.forgetError && props.forgetError ? (
                      <Alert color="danger" className="text-center mb-4" style={{ marginTop: "13px" }}>
                        {props.forgetError}
                      </Alert>
                    ) : null}
                    {props.forgetSuccessMsg ? (
                      <Alert color="success" className="text-center mb-4" style={{ marginTop: "13px" }}>
                        {props.forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                      </div>
                      <Row className="row mb-0">
                        <Col className="col-12 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center login-p mobile">
                <p>
                 Remember it ?
                  <Link to="/login" className="fw-medium text-primary">
                    Login in here
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} Smart School, Created
                  <i className="mdi mdi-heart text-danger"></i> by Chadrack_code
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func
}

const mapStatetoProps = state => {
  const { forgetError, forgetSuccessMsg } = state.ForgetPassword
  return { forgetError, forgetSuccessMsg }
}

export default withRouter(
  connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
)
